module.exports = __webpack_public_path__ + "img/api-keys.f2e62350.svg";